import { render } from "./testdetailsCardView.vue?vue&type=template&id=3f507aac&scoped=true"
import script from "./testdetailsCardView.vue?vue&type=script&lang=js"
export * from "./testdetailsCardView.vue?vue&type=script&lang=js"

import "./testdetailsCardView.vue?vue&type=style&index=0&id=3f507aac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f507aac"]])

export default __exports__